module.exports = __webpack_public_path__ + "static/img/8.9bfc15c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/8.png
// module id = kmPr
// module chunks = 0